// BFSG
import * as React from 'react'
import styled from 'styled-components'
import Link from 'theme/atoms/Link'
import useLazyImgSrc from 'hooks/useLazyImgSrc'
import { OptImg } from '../../../utils/imageOptimization'
import { ReactComponent as LinkArrow } from 'assets/arrow-button-right.svg'
import usePersonalization from 'hooks/usePersonalization'
import theme from 'theme'

type Props = {
  disclaimer: string
  title: string
  link: string
  showMoreText?: string
  teaserImage: string
  optImg: OptImg
}

export default function Card(props: Props) {
  const [ref, imgUrl] = useLazyImgSrc<HTMLImageElement>(props.optImg, 100)
  const personalization = usePersonalization()
  return (
    <Wrapper
      className="Card"
      to={props.link}
      data-cy-ctx="molecules/Card"
      data-cy-handle="link"
      onClick={() => personalization.trackClick()}
    >
      <div>
        <TeaserImage ref={ref} $url={imgUrl} className="teaser-image" />
        <div className="text-box">
          <div className="title">{props.title}</div>
          <span>{props.disclaimer}</span>
        </div>
        {props.showMoreText && (
          <div data-cy-state="showMore" className="show-more-wrapper">
            <span
              className="show-more"
              data-cy-handle="showMore"
              onClick={() => personalization.trackClick()}
            >
              {props.showMoreText}
            </span>
            <LinkArrow />
          </div>
        )}
      </div>
    </Wrapper>
  )
}

const TeaserImage = styled.div<{ $url: string }>`
  background-image: url(${(props) => props.$url});
  background-size: cover;
  width: 100%;
  height: 15rem;
`

const Wrapper = styled(Link)`
  > div {
    > .text-box {
      > .title {
        ${theme.ty('rc-base')}
        margin-bottom: 0.3125rem;
        @media (min-width: ${theme.ms.MD}px) {
          ${theme.ty('rc-2xl')}
        }
      }
    }
  }
`
